import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-[#F2F7F8]" data-id="element-82" data-mp="3djueifd6yagl">
      <div className="max-w-5xl mx-auto" data-id="element-83" data-mp="3dkm9pp2vm66c">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-[#0F4C5C] text-center mb-12 uppercase" data-id="element-84" data-mp="3ij70yz05hfin">
          Everything Included in <span className="text-[#0B7A7A]" data-id="element-85" data-mp="3mlttz38k56hf">Dental Instructor Atlas</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-86" data-mp="xtq06h7b352q">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-[#0F4C5C] border-b-4 border-[#A7B7C1] rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-87" data-mp="11t8nfjmlns8q">
              <Icon size={28} className="text-white" aria-hidden="true" data-id="element-88" data-mp="1dag8gp0evfi6" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-89" data-mp="18bmt0r1kdefd">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-90" data-mp="14cdyhjyp9cir">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3" data-id="element-91" data-mp="ujyll129fe4q">
              <span className="w-9 h-9 rounded-lg bg-[#0F4C5C] text-white flex items-center justify-center shrink-0" data-id="element-92" data-mp="pisnenptyynt">
                <Icon size={18} aria-hidden="true" data-id="element-93" data-mp="gk78r3nhc3sb" />
              </span>
              <span className="text-[#0F4C5C] font-bold text-xs uppercase leading-tight" data-id="element-94" data-mp="gmjrvk4z4k6y">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-[#0F4C5C] rounded-3xl p-8 md:p-12 shadow-xl shadow-[#0F4C5C]/10 text-center" data-id="element-95" data-mp="1xiat68vlyo1">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-8" loading="lazy" data-id="element-96" data-mp="3t4b9a2cabjov" />
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#0F4C5C] mb-1" data-id="element-97" data-mp="pm1aixdv134i">
            DENTAL INSTRUCTOR <span className="text-[#0B7A7A]" data-id="element-98" data-mp="ay6f398gwknq">ATLAS</span>
          </p>
          <p className="text-base font-semibold text-[#0A6464] mb-3" data-id="element-99" data-mp="fwhq3nai117j">
            The Complete 6-IN-1 Visual Dentistry Teaching &amp; Clinical Training System for Dental Instructors, Clinical Faculty &amp; Dental Educators
          </p>
          <p className="text-base text-slate-700/80 max-w-2xl mx-auto mb-8" data-id="element-100" data-mp="18fx0xwwevjqz">
            A complete visual training system created to help dental instructors plan, explain, demonstrate
            and assess every core clinical skill with more clarity, structure and confidence.
          </p>
          <p className="text-sm font-bold tracking-widest text-[#0F4C5C] mb-1" data-id="element-101" data-mp="31vrkkw7y3228">YOUR PRICE:</p>
          <p className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B7A7A] mb-6" data-id="element-102" data-mp="2xvr99kg576ze">
            {PRICE_LABEL}
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-103" data-mp="256abs8do0zwb">
            {PRIMARY_CTA}
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-104" data-mp="2e6gv4aw1ou3e">
            Immediate Access · 6 Visual Volumes · 5 Bonuses · One-Time Payment
          </p>
          <div className="pt-8 border-t border-slate-200" data-id="element-105" data-mp="3ujdpq8wtmer7">
            <p className="text-2xl md:text-3xl font-bold tracking-tight text-[#0F4C5C] mb-2 uppercase" data-id="element-106" data-mp="3pmx2ri1cy6fp">
              Stop Planning Every Dental Session From Scratch.
            </p>
            <p className="text-lg font-semibold text-[#0A6464]" data-id="element-107" data-mp="tpr1r2imvezk">OPEN IT. CHOOSE IT. SHOW IT. TEACH IT.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}